import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import EmptyTableRow from "../components/EmptyTableRow";
import { Link } from "react-router-dom";
import {
	getAssessmentHistory,
	getChecklistCategory,
} from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import moment from "moment";

const InfoRow = ({ label, value }) => (
	<div className="row py-2 border-bottom">
		<div className="col-md-4 text-sm text-muted text-uppercase">
			{label}
		</div>
		<div className="col-md-8 text-sm font-weight-bold">
			{value || "--"}
		</div>
	</div>
);

const Section = ({ title, children }) => (
	<div className="card shadow mb-4">
		<div className="card-header border-0">
			<h3 className="mb-0" style={{ fontWeight: '600' }}>{title}</h3>
		</div>
		<div className="card-body pt-0">{children}</div>
	</div>
);

const EditAssessment = (props) => {
	const [data, setData] = useState({});
	const [checklist, setChecklist] = useState([]);
	const [viewModal, setViewModal] = useState(false);
	const [selectedHistory, setSelectedHistory] = useState(null);

	const getData = async () => {
		try {
			props.toggleLoader(true);
			const res = await getAssessmentHistory(props.match.params.id);
			setData(res?.data || {});
		} finally {
			props.toggleLoader(false);
		}
	};

	const getChecklist = async () => {
		try {
			const res = await getChecklistCategory();
			setChecklist(res?.data || []);
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		getData();
		getChecklist();
	}, []); // ✅ FIXED (no props dependency)

	const isChecked = (catId, subId) => {
		const category = data?.checklist?.find(
			(c) => c.categoryId === catId
		);

		return category?.items?.includes(subId);
	};

	const isCheckedModal = (catId, subId) => {
		const category = selectedHistory?.checklist?.find(
			(c) => c.categoryId === catId
		);

		return category?.items?.includes(subId);
	};

	return (
		<div className="g-sidenav-show bg-gray-100">
			<div id="wrapper">
				<Leftbar />
				<main className="main-content border-radius-lg">
					<Topbar />

					{/* HEADER */}
					<div className="header bg-primary pb-6">
						<div className="container-fluid">
							<div className="header-body">
								<div className="row align-items-center py-3">
									<div className="col-lg-6 col-7">
										<nav
											aria-label="breadcrumb"
											className="d-none d-md-inline-block ml-md-4"
										>
											<ol className="breadcrumb breadcrumb-links breadcrumb-dark">
												<li className="breadcrumb-item">
													<Link to="/dashboard">
														<i className="fas fa-home" />
													</Link>
												</li>
												<li className="breadcrumb-item">
													<a href="/assessment">Assessment</a>
												</li>
											</ol>
										</nav>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* CONTENT */}
					<div className="container-fluid mt--6">
						{/* VITAL SIGNS */}
						<Section title="Vital Signs">
							<InfoRow label="Blood Pressure" value={data.blood_pressure} />
							<InfoRow label="Temperature" value={data.temperature} />
							<InfoRow label="Pulse Rate" value={data.pulse_rate} />
							<InfoRow label="SPO2" value={data.spo2} />
							<InfoRow label="Baby Weight" value={data.baby_weight} />
						</Section>

						{/* MOTHER ASSESSMENT */}
						<Section title="Mother Assessment">
							<InfoRow label="Mother Name" value={data.mother_name} />
							<InfoRow label="Visit Type" value={data.visit_type} />
							<InfoRow label="Visit Notes" value={data.visit_notes} />
							<InfoRow
								label="Escalated"
								value={data.is_escalated ? "Yes" : "No"}
							/>

							{data.is_escalated && (
								<InfoRow
									label="Escalation Reason"
									value={data.escalation_reason}
								/>
							)}
						</Section>

						{/* CHECKLIST */}
						<Section title="Checklist">
							{checklist.length === 0 ? (
								<div className="text-muted">No checklist available</div>
							) : (
								checklist.map((cat, i) => (
									<div key={i} className="mb-4">
										<h6 className="text-uppercase text-muted mb-3">
											{cat.name}
										</h6>

										{cat.sub_categories.map((sub, j) => {
											const checked = isChecked(cat._id, sub._id);

											return (
												<div className="row py-2 border-bottom align-items-center">

													<div className="col-4">
														{sub.name}
													</div>

													<div className="col-4">
														{checked && (
															<i className="fas fa-check-circle text-success" />
														)}
													</div>

												</div>
											);
										})}
									</div>
								))
							)}
						</Section>
						{/* HISTORY */}
						<Section title="Visit History">
							<div className="table-responsive">
								<table className="table align-items-center table-flush">
									<thead className="thead-light">
										<tr>
											<th>Updated by</th>
											<th>Updated at</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody>
										{data?.visit_form_history?.length > 0 ? (
											data.visit_form_history.map((item, i) => (
												<tr key={i}>
													<td data-label="Updated By">{item?.updated_by?.name}</td>
													<td data-label="Updated At">{moment(item?.updatedAt).format('DD MMM YYYY, hh:mm a')}</td>

													<td data-label="Action">
														<button
															className="btn btn-sm"
															style={{
																border: "1px solid #C22627",
																color: "#C22627",
																borderRadius: "20px",
																padding: "4px 10px",
																fontWeight: 600
															}}
															onClick={() => {
																// console.log(item, '.........')
																setSelectedHistory(item.data);
																setViewModal(true);
															}}
														>
															View
														</button>
													</td>
												</tr>
											))
										) : (
											<EmptyTableRow colSpan={3} />
										)}
									</tbody>
								</table>
							</div>
						</Section>

					</div>
				</main>

				<Modal
					show={viewModal}
					onHide={() => setViewModal(false)}
					size="lg"
					centered
				>
					<Modal.Header closeButton>
						<h5 className="mb-0">Visit History Detail</h5>
					</Modal.Header>

					<Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
						{selectedHistory && (
							<>
								{/* VITAL */}
								<Section title="Vital Signs">
									<InfoRow label="Blood Pressure" value={selectedHistory.blood_pressure} />
									<InfoRow label="Temperature" value={selectedHistory.temperature} />
									<InfoRow label="Pulse Rate" value={selectedHistory.pulse_rate} />
									<InfoRow label="SPO2" value={selectedHistory.spo2} />
									<InfoRow label="Baby Weight" value={selectedHistory.baby_weight} />
								</Section>

								{/* MOTHER */}
								<Section title="Mother Assessment">
									<InfoRow label="Mother Name" value={selectedHistory.mother_name} />
									<InfoRow label="Visit Type" value={selectedHistory.visit_type} />
									<InfoRow label="Visit Notes" value={selectedHistory.visit_notes} />
									<InfoRow
										label="Escalated"
										value={selectedHistory.is_escalated ? "Yes" : "No"}
									/>

									{selectedHistory.is_escalated && (
										<InfoRow
											label="Escalation Reason"
											value={selectedHistory.escalation_reason}
										/>
									)}
								</Section>

								{/* ✅ CHECKLIST (NEW) */}
								<Section title="Checklist">
									{checklist.length === 0 ? (
										<div className="text-muted">No checklist available</div>
									) : (
										checklist.map((cat, i) => (
											<div key={i} className="mb-4">
												<h6 className="text-uppercase text-muted mb-3">
													{cat.name}
												</h6>

												{cat.sub_categories.map((sub, j) => {
													const checked = isCheckedModal(cat._id, sub._id);

													return (
														<div className="d-flex align-items-center py-2 border-bottom">
															<span>{sub.name}</span>

															{checked && (
																<i className="fas fa-check-circle text-success ml-2" />
															)}
														</div>
													);
												})}
											</div>
										))
									)}
								</Section>
							</>
						)}
					</Modal.Body>
				</Modal>

			</div>
		</div>
	);
};

export default connect(null, { toggleLoader })(EditAssessment);
